<div class="text-base bg-white/40 dark:bg-qo-dark-700/40">
  <div class="qo-spacing max-w-qo mx-auto">

      <div class="flex flex-wrap pt-10 md:pt-20 md:pb-10">
          <div class="flex justify-between items-center md:flex-col md:justify-start md:items-start w-full md:w-2/5 mb-10" >
            <img class="h-8" src="assets/images/logo-quick-off.svg" alt="Quick-Off" />

            <div class="flex gap-2 justify-center">
                <a matRipple href="https://www.linkedin.com/company/quickoff" rel="noopener" target="_blank" class="inline-flex hover:opacity-80 w-8 h-8 md:mt-5" title="Facebook">
                    <img class="dark:grayscale dark:invert" src="assets/images/linkedin.svg" alt="linkedin" />
                </a>
                <a matRipple href="https://www.instagram.com/quickoffevent/" rel="noopener" target="_blank" class="inline-flex hover:opacity-80 w-8 h-8 md:mt-5" title="Facebook">
                    <img class="dark:grayscale dark:invert" src="assets/images/instagram.svg" alt="instagram" />
                </a>
                <a matRipple href="https://www.facebook.com/quick.offf" rel="noopener" target="_blank" class="inline-flex hover:opacity-80 w-8 h-8 md:mt-5" title="Facebook">
                    <img class="dark:grayscale dark:invert" src="assets/images/facebook.svg" alt="facebook" />
                </a>
            </div>
          </div>

          <div class="w-3/6 md:w-1/5 mb-10 pr-2">
              <p class="mb-3"><strong i18n>Solutions</strong></p>
              <ul>
                  <li><a class="inline-block py-1.5" [routerLink]="NavigationService.Routes.Qoezion()" i18n>Qoezion</a></li>
                  <li><a class="inline-block py-1.5" [routerLink]="NavigationService.Routes.Qomeet()" i18n>Qomeet</a></li>
                  <li><a class="inline-block py-1.5" [routerLink]="NavigationService.Routes.ProjectManagement()" i18n>Gestion événementielle</a></li>
                  <li><a class="inline-block py-1.5" href="https://www.qoezion.com" target="_blank" i18n>Communauté bénévoles Qoezion</a></li>
              </ul>
          </div>
          <!-- <div class="w-3/6 md:w-1/5 mb-10 pr-2">
              <a [routerLink]="NavigationService.Routes.Customers()" class="mb-3"><strong i18n>Clients</strong></a>
          </div> -->
          <div class="w-3/6 md:w-1/5 mb-10 pr-2">
              <p class="mb-3"><strong i18n>La société</strong></p>
              <ul>
                <li><a class="inline-block py-1.5" [routerLink]="NavigationService.Routes.AboutUs()" i18n>A propos</a></li>
                @if(locale === 'fr') {
                    <li><a class="inline-block py-1.5" target="_blank" href="https://webforms.pipedrive.com/f/72vCIPRtXsD72MgIlHMn313jMMKYYYTgRCdXjmVTOSc0ZSeYdqQs61fKzVzVxLymUb" i18n>Contactez-nous</a></li>
                } 
                @else {
                    <li><a class="inline-block py-1.5" [routerLink]="NavigationService.Routes.Contact()" i18n>Contactez-nous</a></li>
                }
                <li><a class="inline-block py-1.5" [routerLink]="NavigationService.Routes.Newsletter()" i18n>Newsletter</a></li>
                <li><a class="inline-block py-1.5" [href]="environmentSettings.BlogUrl" i18n>Blog</a></li>
              </ul>
          </div>

          <div class="w-3/6 md:w-1/5 mb-10 pr-2">
              <p class="mb-3"><strong i18n>Langues</strong></p>
              <ul>
                  <li><a class="inline-block py-1.5" href="/en">English</a></li>
                  <li><a class="inline-block py-1.5" href="/fr">Français</a></li>
              </ul>
          </div>
      </div>

      <div class="border-t border-solid border-white/60 dark:border-white/10 pt-5 md:pt-7 pb-20 md:pb-7 flex flex-col sm:flex-row justify-between items-center text-sm">
          <span class="mb-2 sm:m-0">© {{today|date:'yyyy'}} Quick-Off</span>

          <ul class="flex flex-col sm:flex-row items-center sm:space-x-8">
              <li><a class="block py-2" [routerLink]="NavigationService.Routes.LegalNotices()" i18n>Mentions légales</a></li>
              <li><a class="block py-2" [routerLink]="NavigationService.Routes.TermsAndConditions()" i18n>Politique de confidentialité</a></li>
          </ul>
      </div>
  </div>
</div>


